<template>

    <div class="info-box">
        <div class="info-box__item info-box__alon">
            <div class="info-box__alon-inner">
                <div class="info-box__alon-text">
                    <h3 class="info-box__tit">본인 예약</h3>
                    <p class="info-box__desc">본인이 예약하실 경우 예약을 도와드립니다.</p>
                </div>
                <div class="info-box__alon-icon">
                    <img src="/resource/icon/self-reservation_icon.svg" alt="" v-if="$store.state.hospStore.hostNm === '대동맥혈관병원'">
                    <img src="/resource/icon/self-reservation_icon-brain.svg" alt="" v-if="$store.state.hospStore.hostNm === '뇌혈관병원'">
                    <img src="/resource/icon/self-reservation_icon-mom.svg" alt="" v-if="$store.state.hospStore.hostNm === '엄마아기병원'">
                    <img src="/resource/icon/self-reservation_icon-blood.svg" alt="" v-if="$store.state.hospStore.hostNm === '혈액암병원'">
                </div>
            </div>
            <div class="botton-wrap">
                <a href="javascript:;" class="main-button c-main" @click="goReservation">본인예약하기</a>
            </div>
        </div>

        <div class="info-box__item info-box__agent">
            <div class="info-box__agent-inner">
                <h3 class="info-box__tit">대리인 예약</h3>
                <p class="info-box__desc red">*최초 1회 실명인증 및 본인인증은 대리인 명의로 진행해주세요.</p>
                <div class="info-box__input">
                    <label><input type="text" placeholder="환자명" v-model="patInfo.patName"></label>
                    <label><input type="text" placeholder="환자 주민등록번호" v-model="patInfo.patRrn" @input="this.$commonUtils.numberOnly" maxlength="13"></label>
                    <label><input type="text" placeholder="휴대전화번호" v-model="patInfo.patHpNo" @input="this.$commonUtils.numberOnly"></label>
                </div>
            </div>
            <div class="botton-wrap">
                <a href="javascript:;" class="main-button c-sub" @click="showPopupAgent">대리인 예약하기</a>
            </div>
        </div>
    </div>

    <PopupCertification v-if="popupVisible" @cancelNameCheck="hidePopup"/>
    <popup-agent v-if="agentPopupVisible" :patInfo="patInfo" @confirmPopup="confirmPopupAgent" @cancelAgree="hidePopupAgent" />
</template>


<script>
import PopupCertification from '@/components/kr/popup/popup_certification'
import PopupAgent from '@/components/kr/popup/popup_agent'

export default {
    components: {
        PopupCertification,
        PopupAgent
    },
    data() {
        return {
            popupVisible: false,
            agentPopupVisible: false,
            patInfo: {
                patName: '',
                patRrn: '',
                patHpNo: ''
            }
        };
    },
    methods: {
        showPopup() {
            if(!this.patName){
                alert('이름을 입력해주세요.')
                return
            }
            if(!this.patHpNo){
                alert('전화번호를 입력해주세요.')
                return
            }
            this.popupVisible = true;
        },
        hidePopup() {
            this.popupVisible = false;

            //뒤로가기
            this.$router.go(-1)
        },
        checkSuccess(data){
            if(data.iReturn === 0 && data.ptNo !== '' && data.ptNo !== null){
                // this.hidePopup()
                this.popupVisible = false;
                this.$store.state.myInfoStore.ptNo = data.ptNo;
                this.$router.push({path: '/kr/reserve/reservation'})
            }else{
                alert(data.sMessage)
            }
        },
        showPopupAgent(){
            if(!this.patInfo.patName){
                alert('환자명을 입력해주세요.')
                return
            }
            if(!this.patInfo.patRrn){
                alert('주민등록번호를 입력해주세요.')
                return
            }
            if(!this.patInfo.patHpNo){
                alert('전화번호를 입력해주세요.')
                return
            }

            //검증
            if(this.patInfo.patRrn.length < 13){
                alert('주민번호 길이가 올바르지 않습니다.')
                return
            }

            const reg01 = this.patInfo.patRrn.substring(0, 6)
            const reg02 = this.patInfo.patRrn.substring(6, 13)

            this.axios.get(this.api.member.nameCheck, {
                params: {
                    gubun: 'R',
                    reg01: reg01,
                    reg02: reg02,
                    name: this.patInfo.patName
                }
            }).then(response => {

                if(response.data.result === "1") {
                    this.agentPopupVisible = true
                }else{
                    alert(response.data.resultMsg)
                }
            })

        },
        confirmPopupAgent(data){
            this.agentPopupVisible = false

            this.$store.state.patInfoStore = {}
            this.$store.state.patInfoStore = {
                patName: this.patInfo.patName,
                patBirth: this.updateRrn(this.patInfo.patRrn),
                patHpNo: this.patInfo.patHpNo,
                ptNo: data.ptNo
            }

            this.$router.push({path: '/kr/reserve/reservation'})
        },
        hidePopupAgent(){
            this.agentPopupVisible = false
        },
        updateRrn(rrn){	
            var year = ''
            var month = rrn.substring(2, 4);
            var day = rrn.substring(4, 6);
            
            if(rrn.substr(6, 1) == 1 || rrn.substr(6, 1) == 2){
                year = "19" + rrn.substring(0, 2);
            }
            else{
                year = "20" + rrn.substring(0, 2);
            }   
                
            return year + month + day
        },
        goReservation(){
            this.$store.state.patInfoStore = {}

            this.$router.push({path: '/kr/reserve/reservation'})
        }
    },
    mounted() {
        this.$store.commit('setNiceType', '')
        this.$store.state.patInfoStore = {}
        this.myInfo = this.$store.state.myInfoStore

        if(this.$commonUtils.isEmpty(this.myInfo.ptNo)){
            this.popupVisible = true
        }

        window.addEventListener("message", (event) => {
            try {

                if (event.data && event.data.source === "react-devtools-content-script") {
                    return;
                }

                const receivedData = JSON.parse(event.data); // JSON 파싱
                if (receivedData.callFunction === "checkSuccess") {
                    this.checkSuccess(receivedData.data); // 데이터 전달
                }
            } catch (e) {
                console.error("Invalid JSON data received:", e);
            }
        });
    }

};
</script>